import React, { FC, ReactNode, HTMLProps, RefObject } from 'react'
import {
  FilledButton,
  LinkButton,
  LinkWhiteButton,
  OutlinedButton,
  TextButton,
  GreenButton,
  GreenButtonWide,
  GreenOutlinedButton,
  RedDot,
  BlueButton,
  WhiteButton,
  WhiteButtonBlueText
} from './Button.elements'

export type ButtonVariant
  = 'default'
  | 'text'
  | 'outlined'
  | 'link'
  | 'link-white'
  | 'green'
  | 'green-wide'
  | 'green-outlined'
  | 'white'
  | 'dark-blue'
  | 'white-blue-text'

export type Props = HTMLProps<HTMLButtonElement> & {
  disabled?: boolean
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => any
  className?: any
  children: ReactNode
  variant?: ButtonVariant
  type?: 'button' | 'submit' | 'reset' | undefined
  styles?: string[]
  circled?: boolean
  enableAlert?: boolean
  fixedFont?: boolean
  btnRef?: RefObject<HTMLButtonElement>
}

export const Button: FC<Props> = ({
  disabled,
  onClick,
  children,
  variant,
  circled,
  enableAlert,
  btnRef,
  ...props
}) => {
  let BtnVariant

  switch (variant) {
    case 'text':
      BtnVariant = TextButton
      break
    case 'outlined':
      BtnVariant = OutlinedButton
      break
    case 'link':
      BtnVariant = LinkButton
      break
    case 'link-white':
      BtnVariant = LinkWhiteButton
      break
    case 'green':
      BtnVariant = GreenButton
      break
    case 'green-wide':
      BtnVariant = GreenButtonWide
      break
    case 'green-outlined':
      BtnVariant = GreenOutlinedButton
      break
    case 'white':
      BtnVariant = WhiteButton
      break
    case 'dark-blue':
      BtnVariant = BlueButton
      break
    case 'white-blue-text':
      BtnVariant = WhiteButtonBlueText
      break
    default:
      BtnVariant = FilledButton
  }

  let RenderedButton = (
    <BtnVariant
      disabled={disabled}
      onClick={onClick}
      type="button"
      circled={circled}
      ref={btnRef}
      {...props}
    >
      {enableAlert && <RedDot/>}
      {children}
    </BtnVariant>
  )
  return RenderedButton
}
